var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 49.1666C11.6527 49.1666 0.833313 38.3472 0.833313 25C0.833313 11.6527 11.6527 0.833313 25 0.833313C38.3472 0.833313 49.1666 11.6527 49.1666 25C49.1666 38.3472 38.3472 49.1666 25 49.1666ZM37.0833 34.6666L49.1666 25L37.0833 15.3333V22.5833H17.75V27.4166H37.0833V34.6666Z",
    fill: "#00AFEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5Blue);
export default __webpack_public_path__ + "static/media/vector-5-blue.390495ca0434b09f9743427283699f04.svg";
export { ForwardRef as ReactComponent };